export default __webpack_public_path__ + "static/media/screen_facebook_3_1.8fa23e99.png";